import React, { useMemo } from "react";
import { Chart } from "react-google-charts";
import { ChartWrapperOptions } from "react-google-charts/dist/types";

import { ViewOfTheRoom } from "../../api";
import { divergingScheme4 as colorArray, duo as duoColors, getColor } from "../../common/helpers/colors";

import Loader from "../../common/components/Loader";
import Legend from "./ValueInTheRoomLegend";

interface ValueInTheRoomBarChartProps {
  view: ViewOfTheRoom;
}

const ValueInTheRoomBarChart = ({ view }: ValueInTheRoomBarChartProps) => {

  const colors = (totalValues => {
    if (totalValues === 2) {
      return duoColors;
    }
    const arr: string[] = [];
    for (let i = 0; i < totalValues; i++) {
      arr.push(getColor(colorArray, i, totalValues));
    }
    return arr;
  })(view.data[0].values.length);

  const options: ChartWrapperOptions["options"] = {
    height: view.data.length * 50 + 50,
    chartArea: {
      width: "60%",
    },
    isStacked: true,
    legend: "none",
    colors,
    hAxis: {
      title: view.axes ? view.axes[0] || void 0 : void 0,
      titleTextStyle: {
        fontSize: 12,
        italic: false,
      },
    },
    vAxis: {
      title: view.axes ? view.axes[1] || void 0 : void 0,
    },
  };

  const data = useMemo(() => {
    const arr: any[] = [["Name", ...(view.labels ?? [])]];
    arr.push(...view.data.map(x => [x.name, ...x.values]));
    return arr;
  }, [view]);

  return (
    <>
      <div className="pb-2 position-relative w-100">
        <Chart
          chartType="BarChart"
          data={data}
          options={options}
          height={options.height}
          loader={
            <div style={{ width: "100%", height: options.height }}>
              <Loader show />
            </div>
          }
        />
      </div>
      {!!view.labels && (
        <Legend labels={view.labels} colors={colors} />
      )}
    </>
  );
};

export default ValueInTheRoomBarChart;
